import { GiftSpecialOffer, ProductSpecialOffer, SingleSpecialOffer } from '@telialt/models/src/EshopModel';

export const isSingleSpecialOffer = (modal: ProductSpecialOffer): modal is SingleSpecialOffer => modal.single === true;
export const isGiftSpecialOffer = (modal: ProductSpecialOffer): modal is GiftSpecialOffer => !!modal.single === false;
